import { v4 as uuidv4 } from 'uuid';

import { ACTIV8_CONTENT_STATUS, MEDIA_TYPES } from '../../../constants';
import { STORY_MEDIA_SOURCE } from './storyMediaSources';

export function normalizeActiv8Alternative({ id, type, link }) {
  const item = {
    source: STORY_MEDIA_SOURCE.ACTIV8,
    sourceId: id,
    type,
  };

  if (type === MEDIA_TYPES.VIDEO) {
    return { ...item, posterLink: link };
  }

  return { ...item, link };
}

export function normalizeUsedMedia(item) {
  const normalized = {
    source: item.source,
    sourceId: item.sourceId,
    type: item.type,
  };

  if (item.link) {
    normalized.link = item.link;
  }

  if (item.posterLink) {
    normalized.posterLink = item.posterLink;
  }

  if (item.fileName) {
    normalized.fileName = item.fileName;
  }

  return normalized;
}

export function normalizeFromFind(slide) {
  const item = {
    source: STORY_MEDIA_SOURCE.ACTIV8,
    sourceId: slide.id,
    type: slide.mediaType,
    link: slide.contentDisplayLink,
  };

  if (slide.mediaType === MEDIA_TYPES.VIDEO) {
    return { ...item, posterLink: slide.thumbnailLink };
  }

  return item;
}

export function normalizeFromFavorite({ id, mediaType }) {
  return {
    source: STORY_MEDIA_SOURCE.FAVORITE,
    sourceId: id,
    type: mediaType,
  };
}

export function createUploadingStoryMedia({ fileName, type, posterUrl }) {
  return {
    source: STORY_MEDIA_SOURCE.UPLOADED,
    sourceId: uuidv4(),
    type,
    fileName,
    uploading: true,
    ...(posterUrl ? { posterUrl } : {}),
  };
}

export function normalizeFromLinkedContent({ id, type, link, fileName, posterUrl }) {
  return {
    source: STORY_MEDIA_SOURCE.UPLOADED,
    sourceId: id,
    type,
    link,
    ...(fileName ? { fileName } : {}),
    ...(posterUrl ? { posterUrl } : {}),
  };
}

export function mediaTypeFromFile(file) {
  return file.type.startsWith('video/') ? MEDIA_TYPES.VIDEO : MEDIA_TYPES.IMAGE;
}

export function normalizePoolSelection(media) {
  if (media.source && media.sourceId) {
    return media;
  }

  return normalizeActiv8Alternative({
    id: media.id ?? media.sourceId,
    type: media.type,
    link: media.link,
  });
}

export function isStoryMediaDeleted(item) {
  return item?.status === ACTIV8_CONTENT_STATUS.DELETED;
}

export function getStoryMediaRef(item) {
  return {
    source: item.source,
    sourceId: item.sourceId,
  };
}

export function getStoryMediaId(item) {
  return item?.sourceId ?? item?.id ?? null;
}

export function isUploadedStoryMedia(item) {
  return item?.source === STORY_MEDIA_SOURCE.UPLOADED;
}

export function isStoryMediaUploading(item) {
  return Boolean(item?.uploading);
}

export function getActiv8ContentId(media) {
  if (media?.source === STORY_MEDIA_SOURCE.ACTIV8) {
    return media.sourceId;
  }

  if (media?.id && !media?.source) {
    return media.id;
  }

  return null;
}

export function isActiv8StoryMedia(media) {
  return Boolean(getActiv8ContentId(media));
}

export function getSelectedMediaType(items) {
  return items?.[0]?.type ?? null;
}

export function isMediaTypeConflict(items, incomingType) {
  const selectedType = getSelectedMediaType(items);

  if (!selectedType || !incomingType) {
    return false;
  }

  return selectedType !== incomingType;
}

export function filterFilesByPrimaryType(files) {
  const fileList = Array.from(files ?? []).filter(Boolean);

  if (!fileList.length) {
    return [];
  }

  const primaryType = mediaTypeFromFile(fileList[0]);

  return fileList.filter((file) => mediaTypeFromFile(file) === primaryType);
}
